/**
 * Set options[SkipErrorReporting] to suppress global unauthorized/logout and request-failed/toast
 * events for noncritical requests. Errors still reach the caller's catch.
 * Uses a namespaced string because RequestInfo.options accepts string keys, not symbols.
 */
export const SkipErrorReporting = 'tioSkipErrorReporting';
